"use client";
import style from "./style.module.scss";
import data from "./scripts/datapc.json";
import Close from "@/assets/icons/closeRound.svg";
import LottieAnimation from "@/components/lottieAnimation/lottieAnimation";
import { useState, useEffect, useRef } from "react";
import GiftCouponModal from "@/components/gift/components/coupon";

export default function GiftLayer({ text }: { text: any }) {
  const [hideLayer, setHideLayer] = useState(false);
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [isMultiline, setIsMultiline] = useState(false);
  const textRef = useRef<HTMLParagraphElement>(null);
  const textContainerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (textRef.current && textContainerRef.current) {
      const textWidth = textRef.current.offsetWidth;
      if (textWidth > 135) {
        setIsMultiline(true);
        textRef.current.style.whiteSpace = "normal";
        textRef.current.style.wordBreak = "break-word";
        textRef.current.style.width = "135px";
      } else {
        setIsMultiline(false);
      }
      textContainerRef.current.style.opacity = "1";
    }
  }, [text]);

  return (
    !hideLayer && (
      <div className={style["uk-pc-newcomer-gift"]}>
        <button
          className={style.closeBtn}
          onClick={() => {
            setHideLayer(true);
          }}
        >
          <Close />
        </button>
        <div className={style.icon} onClick={() => setIsOpenModal(true)}>
          <LottieAnimation animationData={data} />
          <div className={style.text} ref={textContainerRef}>
            <p
              ref={textRef}
              style={{
                whiteSpace: isMultiline ? "normal" : "nowrap",
                wordBreak: isMultiline ? "break-word" : "normal",
              }}
            >
              {text}
            </p>
          </div>
        </div>
        <GiftCouponModal isOpenModal={isOpenModal} setOpenModal={setIsOpenModal} />
      </div>
    )
  );
}
